import styled from 'styled-components'

const StyledImg = styled.img`
    width: 15px;
    height: 15px;
    cursor: pointer;
    margin-left: ${props => props.marginLeft}px;
    
`;

export default StyledImg;


// WEBPACK FOOTER //
// ./src/components/Tooltip/styles.js